import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  postContentsLikesCall,
  getContentsLikesCall,
  deleteContentsLikesCall,
  getAdminContentsLikesByContentTypeCall,
  getAdminContentsLikesUsersCall,
  putContentsFavoritesCall,
  deleteContentsFavoritesCall,
} from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  postContentsLikesCall.saga,
  getContentsLikesCall.saga,
  deleteContentsLikesCall.saga,
  getAdminContentsLikesByContentTypeCall.saga,
  getAdminContentsLikesUsersCall.saga,
  putContentsFavoritesCall.saga,
  deleteContentsFavoritesCall.saga,
];

export function* trainingContentsLikesRootSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
